import apiWrapper from '../apiWrapprer'

const endpoints = {
  getMessageDetails: '/frontend/webMethods/Statistics.asmx/GetMessageDetails'
}

export const getMessageDetails = (idList, guid, idMessage) => {
  const url = endpoints.getMessageDetails
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify({
      idList,
      guid,
      idMessage
    })
  }).then(extractData)
}

const extractData = ({ data }) => JSON.parse(data.d)

export const isFrontendError = (result) => {
  return (result.$types && Object.keys(result.$types)[0].split(',').map(k => k.trim()).includes('mailUp.lib.FrontendException')) ||
  (result.$type && (result.$type.match(/mailUp\.lib\.FrontendException/) !== null))
}
